// Système de design Tartina — direction "hybride"
// Énergie de marque (jaune/rouge/chocolat) pour les sections héro & concours,
// base claire raffinée pour le catalogue et la lecture des recettes.
const theme = {
  colors: {
    // Couleurs de marque
    primary: '#E30613',     // Rouge Tartina
    primaryDark: '#B7040F',
    secondary: '#FFDD00',   // Jaune Tartina
    secondaryDark: '#F5C400',
    tertiary: '#7B3F00',    // Marron chocolat
    chocolate: '#4A2600',   // Chocolat foncé (textes sur jaune)
    chocolateMilk: '#9C6B3F',

    // Surfaces
    light: '#FFFFFF',
    dark: '#1A1A1A',
    background: '#FFFBF2',  // Crème très clair (base raffinée)
    cream: '#FFF4D6',       // Crème chaud
    sun: '#FFE45C',         // Jaune doux pour fonds de section
    cardBg: '#FFFFFF',

    // Texte
    textPrimary: '#2B2118',
    textSecondary: '#6B5B4B',

    // Utilitaires
    border: '#F0E6D2',
    success: '#2E7D32',
    star: '#FFB400',
  },
  fonts: {
    primary: '"Nunito", sans-serif',
    secondary: '"Fredoka", sans-serif',
    heading: '"Fredoka", sans-serif',
    body: '"Nunito", sans-serif',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    largeDesktop: '1440px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    small: '6px',
    medium: '12px',
    large: '20px',
    pill: '999px',
    circle: '50%',
  },
  shadows: {
    sm: '0 2px 8px rgba(74, 38, 0, 0.08)',
    md: '0 8px 24px rgba(74, 38, 0, 0.12)',
    lg: '0 16px 40px rgba(74, 38, 0, 0.16)',
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
};

export default theme;
